/**
 * 优惠券公共js
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/1/30      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import {symbolMoneyUtil} from '@utils/utils';
import dayjs from "dayjs";
    /*
    * 使用条件
    * @needHtml 是否返回Html，默认 false
    * */
    export function getTip(item={},serverWindow,needHtml=false) {
        let type = item.type||'discount';
        let _window = serverWindow||window;
        if(type==='discount'){
            if(item.useMinTotalPrice){
                if(item.isLimitedPrice){
                    // return __getServerLanguage(`订单满${item.symbol}${item.useMinTotalPrice}可用，最多抵扣${item.symbol}${item.discountMaxPrice}`);
                    if(needHtml){
                        // return __getServerLanguage('DingDanManKeYongZuiDuoZheKou',`<span>${item.symbol}${item.useMinTotalPrice}</span>`,`<span>${item.symbol}${item.discountMaxPrice}</span>`);
                        return __getServerLanguage('DingDanManKeYongZuiDuoZheKou',`<span class="ml_4 mr_4">${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)}</span>`,`<span  class="ml_4 mr_4">${symbolMoneyUtil(item.discountMaxPrice,item.symbol,_window)}</span>`);
                    }else return __getServerLanguage('DingDanManKeYongZuiDuoZheKou',` ${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)} `,` ${symbolMoneyUtil(item.discountMaxPrice,item.symbol)} `)
                //     return __getServerLanguage('DingDanManKeYongZuiDuoZheKou',`${item.symbol}${item.useMinTotalPrice}`,`${item.symbol}${item.discountMaxPrice}`)
                }else {
                    // return __getServerLanguage(`订单满${item.symbol}${item.useMinTotalPrice}可用，折扣金额不限`);
                    if(needHtml){
                        // return __getServerLanguage('DingDanManKeYongZheKouJinEBuXian',`<span>${item.symbol}${item.useMinTotalPrice}</span>`);
                        return __getServerLanguage('DingDanManKeYongZheKouJinEBuXian',`<span class="ml_4 mr_4">${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)}</span>`);
                    }else return __getServerLanguage('DingDanManKeYongZheKouJinEBuXian',` ${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)} `);
                    // return __getServerLanguage('DingDanManKeYongZheKouJinEBuXian',`${item.symbol}${item.useMinTotalPrice}`);
                }
            }else {
                if(item.isLimitedPrice){
                    // 无使用门槛，最多可抵扣{0}
                    if(needHtml){
                        // return __getServerLanguage('WuShiYongMenKanZuiDuo',`<span>${item.symbol}${item.discountMaxPrice}</span>`);
                        return __getServerLanguage('WuShiYongMenKanZuiDuo',`<span class="ml_4 mr_4">${symbolMoneyUtil(item.discountMaxPrice,item.symbol,_window)}</span>`);
                    }else return __getServerLanguage('WuShiYongMenKanZuiDuo',` ${symbolMoneyUtil(item.discountMaxPrice,item.symbol,_window)} `)
                    // return __getServerLanguage('WuShiYongMenKanZuiDuo',`${item.symbol}${item.discountMaxPrice}`)
                }else {
                    //无使用限制
                    return __getServerLanguage('WuShiYongXianZhi');
                }
            }
        }

        if(type==='full_reduce'){
            // return __getServerLanguage(`满${item.symbol}${item.useMinTotalPrice}可用`);
            if(needHtml){
                // return __getServerLanguage('ManKeYong',`<span>${item.symbol}${item.useMinTotalPrice}</span>`);
                return __getServerLanguage('ManKeYong',`<span class="ml_4 mr_4">${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)}</span>`);
            }else return __getServerLanguage('ManKeYong',` ${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)} `);
            // return __getServerLanguage('ManKeYong',`${item.symbol}${item.useMinTotalPrice}`);
        }

        if(type==='cash'){
            // return __getServerLanguage(`满${item.symbol}${item.useMinTotalPrice}可用`);
            if(needHtml){
                // return __getServerLanguage('ManKeYong',`<span>${item.symbol}${item.useMinTotalPrice}</span>`);
                return __getServerLanguage('ManKeYong',`<span class="ml_4 mr_4">${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)}</span>`);
            }else return __getServerLanguage('ManKeYong',` ${symbolMoneyUtil(item.useMinTotalPrice,item.symbol,_window)} `);
            // return __getServerLanguage('ManKeYong',`${item.symbol}${item.useMinTotalPrice}`);
        }
        return '-';
    }

    //商品范围类型
    export function goodsRangeType(item={},serverWindow) {
        let type = item.goodsRangeType||'all';
        let _window = serverWindow||window;
        if(type==='all'){
            return __getServerLanguage(`QuanBuShangPinKeYong`);
        }

        if(type==='category'){
            return __getServerLanguage(`ZhiDingLeiMuKeYong`);
        }

        if(type==='brand'){
            return __getServerLanguage(`ZhiDingPinPaiKeYong`);
        }

        if(type==='goods'){
            return __getServerLanguage(`ZhiDingShangPinKeYong`);
        }
        if(type==='trends_goods'){
            return __getServerLanguage(`ZhiDingShangPinKeYong2`,item.skuNo||"-");
        }
        return '-';
    }
    // 时间范围
    export function getTime(item, serverWindow, isHand) {
        let _window = serverWindow||window;
        //如果是手动&&未领取&&类型为‘有效天数’
        if (isHand && item.effectiveType == 'effective_days') {
            return __getServerLanguage(`LingQuanHouNTianNeiYouXiao`, item.effectiveDays || 0);
        } else {
            return `${(dayjs && item.effectiveStartTime) ? dayjs(item.effectiveStartTime).format('DD/MM/YYYY') : ''}~${(dayjs && item.effectiveEndTime) ? dayjs(item.effectiveEndTime).format('DD/MM/YYYY') : ''}`
        }
    }
    /**
     * 获取链接
     * @param item
     */
    // export function getLink(item={}) {
    //     if(item.link){
    //         return item.link;
    //     }
    //
    //     if(item.goodsRangeType==='brand'){
    //         return `/${__SITE.siteLink}/b-${item.brandId}.html?sort=default_desc`
    //     }
    //
    //     return `/${__SITE.siteLink}/search`;
    // }
